import { defineMessages } from 'react-intl'

export interface subscriptionFrequencyMessage {
  id: string
  defaultMessage: string
  value?: string
}

export const subscriptionFrequencyMessages = defineMessages({
  TWO_WEEKS: {
    id: 'TWO_WEEKS',
    defaultMessage: 'Ships Every 2 weeks',
    value: '2 weeks',
  },
  FOUR_WEEKS: {
    id: 'FOUR_WEEKS',
    defaultMessage: 'Ships Every 4 weeks',
    value: '4 weeks',
  },
  EIGHT_WEEKS: {
    id: 'EIGHT_WEEKS',
    defaultMessage: 'Ships Every 8 weeks',
    value: '8 weeks',
  },
  THREE_MONTHS: {
    id: 'THREE_MONTHS',
    defaultMessage: 'Ships Every 3 months',
    value: '3 months',
  },
  SIX_MONTHS: {
    id: 'SIX_MONTHS',
    defaultMessage: 'Ships Every 6 months',
    value: '6 months',
  },
  ONE_DAY: {
    id: 'ONE_DAY',
    defaultMessage: 'Ships Every 1 day',
    value: '1 day',
  },
})

export const subscriptionFrequencyMessagesV2 = defineMessages({
  TWO_WEEKS: {
    id: 'SUBSCRIPTION_FREQUENCY_TWO_WEEKS',
    defaultMessage: 'shipped every 2 weeks',
    value: '2 weeks',
  },
  FOUR_WEEKS: {
    id: 'SUBSCRIPTION_FREQUENCY_FOUR_WEEKS',
    defaultMessage: 'shipped every 4 weeks',
    value: '4 weeks',
  },
  EIGHT_WEEKS: {
    id: 'SUBSCRIPTION_FREQUENCY_EIGHT_WEEKS',
    defaultMessage: 'shipped every 8 weeks',
    value: '8 weeks',
  },
  THREE_MONTHS: {
    id: 'SUBSCRIPTION_FREQUENCY_THREE_MONTHS',
    defaultMessage: 'shipped every 3 months',
    value: '3 months',
  },
  SIX_MONTHS: {
    id: 'SUBSCRIPTION_FREQUENCY_SIX_MONTHS',
    defaultMessage: 'shipped every 6 months',
    value: '6 months',
  },
  ONE_DAY: {
    id: 'SUBSCRIPTION_FREQUENCY_ONE_DAY',
    defaultMessage: 'shipped every 1 day',
    value: '1 day',
  },
})

export default subscriptionFrequencyMessages
